import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";

import clsx from "clsx";

import { AppDispatch } from "../../../redux/reducer/store";

import {
  actionGetProjectsList,
  actionGetProjectsFilters,
} from "../../../redux/action/projects/actionProjects";
import {
  reducerProjectsInputValues,
  reducerSetCurrentProject,
} from "../../../redux/reducer/projects/reducers/reducerProjectsList";

import Loader from "../../custom/loader/loader";
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";
import LimitSelect from "../../custom/limitSelect/limitSelect";
import Pagination from "../../pagination/pagination";
import { formatDateWithDots } from "../../../utils/formatDate";
import { IProjestListOptions } from "../../../types/projectsInterface";

import "../table.scss";

import styles from "./projects.module.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;
const TableProjectsList: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    data,
    limit,
    totalEmps,
    count,
    totalPoses,
    totalRoutes,
    projectsInputValues,
    managersOptions,
  } = useSelector((state: any) => state.projects.projects);
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [isPending, setIsPending] = useState<boolean>(true);

  const actualLimit =
    JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };

  const handleChange = (newLimit: number, newPage: number) => {
    setIsPending(true);
    dispatch(actionGetProjectsList(newLimit, newPage)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem("pageLimit", JSON.stringify(newLimit));
  };

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleProjectClick = (el: IProjestListOptions) => {
    dispatch(reducerSetCurrentProject({ project: [el.project] }));
  };

  useEffect(() => {
    dispatch(actionGetProjectsList(actualLimit, currentPage)).then(() => {
      setIsPending(false);
    });
  }, [actualLimit, dispatch, currentPage]);

  useEffect(() => {
    dispatch(actionGetProjectsFilters());
  }, [dispatch]);

  return (
    <>
      <div className="loader__wrapper">{isPending && <Loader />}</div>

      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        <Toaster position="top-center" toastOptions={{ duration: 5000 }} />

        <div className="filters__container__mobile">
          <div className="filters__item__mobile">
            <div className="routes__multiselect_block">
              <CustomMultiSelect
                setLoading={setIsPending}
                reducer={reducerProjectsInputValues}
                inputValues={projectsInputValues}
                action={actionGetProjectsList}
                options={managersOptions}
                isShowPlaceholder={true}
                resetPages={resetPages}
                pageName="routes"
                placeholder="Менеджер"
                name="managers"
                limit={limit}
              />
            </div>
          </div>
        </div>
        <div className="table__wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="filter__title">Наименование</span>
                </th>
                <th>
                  <span className="filter__title">Сотрудников</span>
                </th>
                <th>
                  <span className="filter__title">Точек</span>
                </th>
                <th>
                  <span className="filter__title">Маршрутов</span>
                </th>
                <th>
                  <div className="routes__multiselect_block">
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      reducer={reducerProjectsInputValues}
                      inputValues={projectsInputValues}
                      action={actionGetProjectsList}
                      options={managersOptions}
                      isShowPlaceholder={true}
                      resetPages={resetPages}
                      pageName="routes"
                      placeholder="Менеджер"
                      name="managers"
                      limit={limit}
                    />
                  </div>
                </th>
                <th>
                  <span className="filter__title">Активирован</span>
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((el: IProjestListOptions, index: number) => (
                <tr key={index}>
                  <td>
                    <Link
                      to={`${el?.project.id}/info`}
                      onClick={() => {
                        handleProjectClick(el);
                      }}
                      className="file__link"
                    >
                      {el.project.name}
                    </Link>
                  </td>
                  <td>{el.emps}</td>
                  <td>{el.poses}</td>
                  <td>{el.routes}</td>
                  <td>{el.manager}</td>
                  <td>
                    {el?.activated ? formatDateWithDots(el?.activated) : ""}
                  </td>
                </tr>
              ))}
            </tbody>

            {data.length > 0 && (
              <tfoot className={styles.tFooter}>
                <tr>
                  <td>
                    <span>Итого:</span>
                  </td>

                  <td>
                    <span>{totalEmps}</span>
                  </td>

                  <td>
                    <span>{totalPoses}</span>
                  </td>

                  <td colSpan={3}>
                    <span>{totalRoutes}</span>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>

        <div className="pagination">
          <div className="pagination__count">Всего: {count}</div>
          <div className="pagination__str">
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            currentPage={currentPage}
            startPage={startPage}
            count={count}
            limit={actualLimit}
            pageName="userReports"
          />
        </div>
      </div>
    </>
  );
};

export default TableProjectsList;
